import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemServicoEditarComponent } from './item-servico-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ItemServicoEditarComponent }
    ])],
    exports: [RouterModule]
})
export class ItemServicoEditarRoutingModule { }
